import { CircularProgress, Box, Button, TextField } from "@mui/material";
import { CenteredBox } from "../../components/layouts/OneViewBox";
import CustomDialog from "../../components/layouts/common/CustomDialog";
import CustomInput from "../../components/inputs/CustomInputs";
import { memo, useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

const ProductSubCategoryCreateUi = ({
  title,
  isUpdate,
  fields,
  setFields,
  loading,
  onSubmit,
  isModal,
  handleAreaModalClose,
}) => {
  const [paramInput, setParamInput] = useState("");

  const addParameter = () => {
    if (paramInput.trim()) {
      setFields({
        ...fields,
        parameters: [...(fields.parameters || []), paramInput.trim()],
      });
      setParamInput("");
    }
  };

  const removeParameter = (index) => {
    setFields({
      ...fields,
      parameters: fields.parameters.filter((_, i) => i !== index),
    });
  };

  return (
    <>
      {!isModal && (
        <CustomDialog
          id={`${isUpdate ? "updateproductsubcategory" : "createproductsubcategory"}`}
          loading={loading}
          err={fields.err}
          onSubmit={onSubmit}
          title={`${isUpdate ? "Update" : "Create"} ${title}`}
          closeText="Close"
          confirmText={`${isUpdate ? "Update" : "Create"}`}
        >
          {loading ? (
            <CenteredBox>
              <CircularProgress />
            </CenteredBox>
          ) : (
            <>
              <CustomInput
                autoFocus={true}
                disabled={loading}
                value={fields.name}
                onChange={(e) =>
                  setFields({ ...fields, err: "", name: e.target.value })
                }
                type="text"
                label={"Product Sub Category Name*"}
              />

              <Box sx={{ mt: 3, mb: 2 }}>
                <Box sx={{ mb: 2 }}>
                  <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
                    <TextField
                      fullWidth
                      size="small"
                      placeholder="Add Parameter"
                      value={paramInput}
                      onChange={(e) => setParamInput(e.target.value)}
                      onKeyPress={(e) => e.key === "Enter" && addParameter()}
                    />
                    <Button
                      variant="contained"
                      size="small"
                      onClick={addParameter}
                      startIcon={<AddIcon />}
                    >
                      Add
                    </Button>
                  </Box>
                </Box>

                {fields.parameters && fields.parameters.length > 0 && (
                  <Box
                    sx={{
                      border: "1px solid #ddd",
                      borderRadius: 1,
                      p: 1,
                      maxHeight: "200px",
                      overflowY: "auto",
                    }}
                  >
                    {fields.parameters.map((param, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "8px",
                          mb: 1,
                          backgroundColor: "#f5f5f5",
                          borderRadius: 1,
                          "&:last-child": { mb: 0 },
                        }}
                      >
                        <span>{param}</span>
                        <Button
                          size="small"
                          color="error"
                          onClick={() => removeParameter(index)}
                          startIcon={<DeleteIcon />}
                        >
                          Delete
                        </Button>
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>
            </>
          )}
        </CustomDialog>
      )}
    </>
  );
};

export default memo(ProductSubCategoryCreateUi);
